import React, { useEffect } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Features from "@/components/Features";
import AtAGlance from "@/components/AtAGlance";
import HowItWorks from "@/components/HowItWorks";
import Press from "@/components/Press";
import FAQ from "@/components/FAQ";
import ProTeaser from "@/components/ProTeaser";
import DownloadCTA from "@/components/DownloadCTA";
import Footer from "@/components/Footer";
import { useDocumentMeta } from "@/seo/useDocumentMeta";

const Index = () => {
  useDocumentMeta("/");

  // Smooth scroll to section when URL has hash
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.substring(1);
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <section id="hero">
          <Hero />
        </section>
        <AtAGlance />
        <section id="features">
          <Features />
        </section>
        <section id="how-it-works">
          <HowItWorks />
        </section>
        <section id="press">
          <Press />
        </section>
        <section id="faq">
          <FAQ />
        </section>
        <ProTeaser />
        <section id="download-cta">
          <DownloadCTA />
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
